export default "__VITE_ASSET__DLmC2Ca2__"